import request from '@/utils/request'
import qs from 'qs'
export async function login(data) {
  return request({
    url: `/user/login`,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data)
  })
}

export async function getUserInfo() {
  return request({
    url: `/user/getLoginUser`,
    method: 'get'
  })
}

export async function getAddUser(data) {
  return request({
    url: `/user/addUser`,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data)
  })
}

export async function deleteUser(data) {
  return request({
    url: `user/deleteUser`,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(data)
  })
}

export async function getUserList(data) {
  return request({
    url: `/user/getUserList`,
    method: 'get'
  })
}

export async function getLogout() {
  return request({
    url: `/user/logout`,
    method: 'get'
  })
}

// 根据用户ID获取用户信息
export function getUserById(id) {
  return request({
    url: `/getUserById/${id}`,
    method: 'get'
  })
}

// 获取当前登录用户信息 (如果后端有此接口)
export function getCurrentUserInfo() {
  return request({
    url: '/user/getLoginUser', // 假设的接口路径
    method: 'get'
  })
}

// === 会员管理 API ===
// 获取指定用户的会员信息
export function getMembershipInfo(userId) {
  return request({
    url: `/user/membership/${userId}`,
    method: 'get'
  });
}

// 更新指定用户的会员信息
export function updateMembershipInfo(userId, data) {
  // data 结构: { isMember: boolean, expiryDate: 'YYYY-MM-DD' }
  return request({
    url: `/user/membership/${userId}`,
    method: 'put',
    data
  });

}
// === 结束会员管理 API ===

export function adminUpdateUser(userId, data) {
  return request({ // 或者您项目中封装的HTTP客户端的其他调用方式
    url: `/user/updateInfo/${userId}`, // 根据API文档的路径
    method: 'post',
    data: data // 请求体
  });
}

// 保存用户设备类型
export function saveUserDeviceType(deviceType) {
  return request({
    url: '/user/device-type',
    method: 'POST',
    data: { deviceType }
  })
}

// 获取用户设备类型
export function getUserDeviceType() {
  return request({
    url: '/user/device-type',
    method: 'GET'
  })
}